import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-tpams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ViewApplicationLocationTpamsConstants } from "./view-application-location-tpams.constants";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { first } from "rxjs";
export let ViewApplicationLocationTpamsComponent = class ViewApplicationLocationTpamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    routerParamsService;
    active;
    propertiesForm;
    erfNoControl = ViewApplicationLocationTpamsConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationTpamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationTpamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationTpamsConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationTpamsConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationTpamsConstants.ADDRESS_CONTROL;
    buildingUseControl = ViewApplicationLocationTpamsConstants.BUILDING_USE_CONTROL;
    erfSizeControl = ViewApplicationLocationTpamsConstants.ERF_SIZE_CONTROL;
    buildingFloorAreaControl = ViewApplicationLocationTpamsConstants.BUILDING_FLOOR_AREA_CONTROL;
    totalValueControl = ViewApplicationLocationTpamsConstants.TOTAL_VALUE_CONTROL;
    titleDeedControl = ViewApplicationLocationTpamsConstants.TITLE_DEED_CONTROL;
    zoneControl = ViewApplicationLocationTpamsConstants.ZONE_CONTROL;
    ownerControl = ViewApplicationLocationTpamsConstants.OWNER_CONTROL;
    propertiesControl = ViewApplicationLocationTpamsConstants.PROPERTIES_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationTpamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationTpamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationTpamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationTpamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationTpamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationTpamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    buildingUseTextPlaceHolder = ViewApplicationLocationTpamsConstants.BUILDING_USE_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = ViewApplicationLocationTpamsConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    buildingFloorAreaTextPlaceHolder = ViewApplicationLocationTpamsConstants.BUILDING_FLOOR_AREA_TEXT_PLACEHOLDER;
    totalValueTextPlaceHolder = ViewApplicationLocationTpamsConstants.TOTAL_VALUE_TEXT_PLACEHOLDER;
    titleDeedTextPlaceHolder = ViewApplicationLocationTpamsConstants.TITLE_DEED_TEXT_PLACEHOLDER;
    zoneLabel = ViewApplicationLocationTpamsConstants.ZONE_LABEL;
    ownerLabel = ViewApplicationLocationTpamsConstants.OWNER_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = true;
    ownerDisableEditing = true;
    ownerDisableDelete = true;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    zones = [];
    showOnlyPropertyAndZoningLayers = true;
    mapComponent;
    isMapLoaded = false;
    application;
    applicationLoaded = false;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.initForm();
        this.listenForSelectedApplication();
        this.getMetadata();
    }
    ngOnInit() {
        this.getZoningLookups();
        this.listenForRouteParamChange();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = false;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
        this.mapService.destroyMap();
        super.ngOnDestroy();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.ownerGroups[0].requiredFields = stepMeta.requiredFields;
    }
    getProperties() {
        if (this.propertiesForm) {
            return this.propertiesForm.get(this.propertiesControl);
        }
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get(this.zoneControl);
    }
    disablePropertyControls(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        propertyControl.get(this.erfNoControl).disable();
        propertyControl.get(this.subdivisionControl).disable();
        propertyControl.get(this.allotmentControl).disable();
        propertyControl.get(this.sgCodeControl).disable();
        propertyControl.get(this.addressControl).disable();
        propertyControl.get(this.buildingUseControl).disable();
        propertyControl.get(this.erfNoControl).disable();
        propertyControl.get(this.buildingFloorAreaControl).disable();
        propertyControl.get(this.totalValueControl).disable();
        propertyControl.get(this.titleDeedControl).disable();
    }
    setZonesControls(newPropertyFormGroup, property) {
        const zonesControl = newPropertyFormGroup.get(this.zoneControl);
        if (property.zonings && property.zonings.length > 0) {
            property.zonings.forEach(zone => {
                let foundZone = false;
                this.zones.forEach(zoneOption => {
                    if (zoneOption.value === zone.zoning) {
                        foundZone = true;
                        const zoneGroup = new FormGroup({
                            id: new FormControl(zone.id),
                            applicationId: new FormControl(zone.applicationId),
                            applicationPropertyId: new FormControl(zone.applicationPropertyId),
                            zones: new FormControl({ value: zoneOption, disabled: true }),
                            deleted: new FormControl(zone.deleted)
                        });
                        zonesControl.push(zoneGroup);
                        zonesControl.disable();
                    }
                });
            });
        }
        else {
            const zoneGroup = new FormGroup({
                id: new FormControl(null),
                applicationId: new FormControl(null),
                applicationPropertyId: new FormControl(null),
                zones: new FormControl({ value: null, disabled: true }),
                deleted: new FormControl(null)
            });
            zonesControl.push(zoneGroup);
            zonesControl.disable();
        }
    }
    setTrueCentroid(geometryArc, newPropertyFormGroup, propertyControl, property) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.applicationViewService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                newPropertyFormGroup.get("centroid").setValue(response.results[0].value);
                propertyControl.push(newPropertyFormGroup);
                this.active = propertyControl.length - 1;
                this.setZonesControls(newPropertyFormGroup, property);
                this.disablePropertyControls(propertyControl.length - 1);
                this.syncMapGeometries();
                this.changeDetectorRefs.markForCheck();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationTpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    handleRouteChange() {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    getZoningLookups() {
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID} and name eq 'Zoning'`,
        };
        this.applicationViewService.getLookupsObservable(params).subscribe({
            next: (response) => {
                if (response && response.value && response.value.length > 0) {
                    const zoningLookups = response.value;
                    this.onGetZoningLookupsCompleted(zoningLookups);
                }
            }, error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetZoningLookupsCompleted(zoningLookups) {
        zoningLookups.forEach(zoneObject => {
            this.zones.push(JSON.parse(zoneObject.content));
        });
        this.getMetadata();
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, ViewApplicationLocationTpamsConstants.LAYER_REF, true);
        }
        this.changeDetectorRefs.markForCheck();
    }
    listenForSelectedApplication() {
        this.selectedApplicationService.$selectedApplication.pipe(first()).subscribe({
            next: (application) => {
                if (application && application.id >= 0 && !this.applicationLoaded) {
                    this.application = application;
                    this.setApplicationData();
                    this.applicationLoaded = true;
                }
            }
        });
    }
    setApplicationData() {
        if (this.application && this.application.properties && this.application.properties.length > 0) {
            if (!this.getProperties()) {
                return;
            }
            else {
                this.getProperties().clear();
                const propertyControl = this.getProperties();
                let index = 0;
                this.selectedApplication?.properties?.sort((a, b) => (b?.id - a?.id));
                this.application.properties.forEach((property) => {
                    // create form groups for each property
                    const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                    const geom = JsonUtils.fromJSON(geometryArc);
                    const newPropertyFormGroup = this.createFormGroup(property, geom);
                    this.setTrueCentroid(geometryArc, newPropertyFormGroup, propertyControl, property);
                    this.syncMapGeometries();
                    index++;
                });
            }
        }
    }
    createFormGroup(property, geom) {
        return new FormGroup({
            property: new FormControl(property),
            erfNo: new FormControl({ value: property.erfNumber, disabled: true }),
            subdivision: new FormControl({ value: property.subdivision, disabled: true }),
            allotment: new FormControl({ value: property.allotment, disabled: true }),
            farmNo: new FormControl({ value: property.farmNumber, disabled: true }),
            sgCode: new FormControl({ value: property.sgCode, disabled: true }),
            address: new FormControl({ value: property.address, disabled: true }),
            buildingUse: new FormControl({ value: property.buildingUse, disabled: true }),
            erfSize: new FormControl({ value: property.erfSize, disabled: true }),
            buildingFloorArea: new FormControl({ value: property.buildingFloorArea, disabled: true }),
            totalValue: new FormControl({ value: property.totalValue, disabled: true }),
            titleDeed: new FormControl({ value: property.titleDeed, disabled: true }),
            geometry: new FormControl(geom),
            centroid: new FormControl(null),
            zones: new FormArray([]),
            owners: new FormControl(property.owners)
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationTpamsComponent = __decorate([
    Component({
        selector: "app-view-application-location-tpams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationLocationTpamsComponent);
